import { RouteRecordRaw } from "vue-router";

export const routesPublic: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Public",
    component: () => import("../../app/public/Public.vue"),
    children: [
      {
        path: "",
        name: "AuthLayout", // Added to avoid Vue Router warning message
        component: () => import("../../app/public/pages/auth/AuthLayout.vue"),
        children: [
          {
            path: "login",
            component: () => import("../../app/public/pages/auth/pages/Login.vue"),
            name: "Login",
            meta: {
              requireAuth: false,
            },
          },
          {
            path: "register",
            component: () => import("../../app/public/pages/auth/pages/Register.vue"),
            name: "Register",
            props: true,
            meta: {
              requireAuth: false,
            },
          },
          {
            path: "auth/reset-password",
            name: "ResetPassword",
            meta: {
              requireAuth: false,
            },
            component: () => import("../../app/public/pages/auth/pages/ResetPassword.vue"),
          },
          {
            path: "auth/invite",
            name: "SignupInvite",
            meta: {
              requireAuth: false,
            },
            component: () => import("../../app/public/pages/auth/pages/SignupInvite.vue"),
          },
          {
            path: "forgot-password",
            name: "ForgotPassword",
            meta: {
              requireAuth: false,
            },
            component: () => import("../../app/public/pages/auth/pages/ForgotPassword.vue"),
          },
        ],
      },
      {
        path: "error/:code",
        name: "ErrorLayout",
        component: () => import("../../app/public/pages/error/ErrorLayout.vue"),
        children: [
          {
            path: "",
            component: () => import("../../app/public/pages/error/pages/ErrorMessage.vue"),
            name: "ErrorMessage",
            meta: {
              requireAuth: false,
            },
          },
        ],
      },
      {
        path: "terms-and-conditions",
        component: () => import("../../app/public/pages/TermsAndConditions.vue"),
        name: "TermsAndConditions",
        meta: {
          requireAuth: false,
        },
      },
      {
        path: "privacy-policy",
        component: () => import("../../app/public/pages/PrivacyPolicy.vue"),
        name: "PrivacyPolicy",
        meta: {
          requireAuth: false,
        },
      },
    ],
  },
];
